import MainStore from "../store/MainStore";

class SearchService {

    getHistoriqueParcelles(comRef, sectionRef, parcelleRef){

        MainStore.dispatch({type: 'SET_HISTORIQUE_PARCELLES', data:{histoParcelles: []}})


        const url = 'Api/geodata/vmap/historique/parcelle'
        const params = {
            "id_par": parcelleRef,
            "cod_com": comRef,
            "section": sectionRef
        }

        if(parcelleRef){
            axios.post(url, params)
                .then(result => {
                    (result.data && result.data.length > 0)
                        ? MainStore.dispatch({type: 'SET_HISTORIQUE_PARCELLES', data:{histoParcelles: result.data}})
                        : null
                }).catch(err => {
                console.log(err)
            })
        }
    }
}

export default SearchService
